export default "<input type=\"text\">"